/**
 * @Auther: Qsan
 * @Date：2018年12月12日 17:23
 * @Desc：核心组件、第三方组件全局安装
 */
import Vue from 'vue'
import core from './core'
import elementUI from './libs/element-ui'
import '@assets/icons' // icon

/**
 * 核心组件安装
 */
Vue.use(core)

/**
 * elementUI组件安装
 */
Vue.use(elementUI, {
    size: 'small'
})



// WEBPACK FOOTER //
// ./src/components/index.js